/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function(){
    $('.col-carousel-nav a').click(function(){
        var id_panel = $(this).attr('href');
        
        if( $(this).hasClass('active') ){
        }else{
            $('.col-carousel-nav a').removeClass('active');
            $('.col-carousel-panel').removeClass('active');

            $(id_panel).addClass('active');
        }

        $(this).addClass('active');

        window.dispatchEvent(new Event('resize'));

        //alert(id_panel);
        return false;
    });

    $(".twentytwenty-container").twentytwenty({no_overlay:true, default_offset_pct: 0.8});

    $('.gridt-container').simpleLoadMore({
      item: 'div.Grid_Testimonials',
      count: 1
    });

    $('.tag-inpt').off().change( function(){
      var newURL = $(this).nextAll('a').attr('href');
      window.location.href = newURL;
    });

    $('.add_to_cart_list').click(function( event ){
      event.preventDefault();
      var ID = $(this).attr("data-var_id");
      addItemToCart( ID, 1);    // paste your id product number
    });

    $('.PageOverlay, button.Drawer__Close').click(function(){
      alternate_remove_ajax();
    }); 

    AnnounceMent();

});

var slideIndex = 0;

function AnnounceMent() {
  var i;
  var slides = document.getElementsByClassName("Grid__Cell_Ann");
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  slideIndex++;
  if (slideIndex > slides.length) {slideIndex = 1}
  slides[slideIndex-1].style.display = "block";
  setTimeout(AnnounceMent, 5000); // Change image every 2 seconds
}

function alternate_remove_ajax(){
  var cart_ajax = $('#sidebar-cart');
  $('.PageOverlay').removeClass('is-visible');
  $(cart_ajax).removeAttr('tabindex').attr('aria-hidden', 'true');
  document.documentElement.classList.remove('no-scroll');
}

//ajax add to cart
function addItemToCart(variant_id, qty){
  var data = {
    "id": variant_id,
    "quantity": qty
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(){
      
      var cart_ajax = document.getElementById('sidebar-cart');
      
      $('.PageOverlay').addClass('is-visible');

      cart_ajax.setAttribute('aria-hidden', 'false');

      cart_ajax.setAttribute('tabindex', '-1');

      document.documentElement.classList.add('no-scroll');

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      //$('#cart-link-header').click();
    }
  });
}

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}


document.querySelector('.Grid__Cell.\\31\\/2.Grid--right h2').outerHTML = '<span>' + document.querySelector('.Grid__Cell.\\31\\/2.Grid--right h2').innerHTML + '</span>';

document.addEventListener("DOMContentLoaded", function() {
  // Select the element using the provided selector
  const plyrPoster = document.querySelector('.plyr__video-wrapper video + div.plyr__poster');

  // Check if the element exists
  if (plyrPoster) {
    // Add role and alt attributes
    plyrPoster.setAttribute('role', 'img');
    plyrPoster.setAttribute('alt', 'thumbnail image.');
  }
});
